import React, { useState, useEffect, memo } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { WSS_URL } from '../services/Constants';
import { getAccessToken } from '../services/AccessToken';
import * as notificationActions from './notification/Actions';
import * as achievementsModalActions from './modals/achievements/Actions';
import * as sidebarActions from './sideBar/Actions';
import * as nextExerciseActions from '../pagesNext/exercise/Actions';

const WebSocketComponent = ({
	createNotification,
	currentRequestId,
	getAiExplanationSuccess,
	setNotificationCount,
	sendAnswerSuccess,
	toggleAchievementsModal,
	userData,
}) => {
	const [messages, setMessages] = useState([]);
	const [socket, setSocket] = useState(null);

	const { username } = userData || {};

	useEffect(() => {
		connectWebSocket();

		return () => {
			if (socket) socket.close();
		};
	}, []);

	useEffect(() => {
		if (!messages?.data) return;

		const { type: messageType, data } = messages;
		const {
			achievement_id,
			text,
			image_url,
			link,
			type,
			new_notifications_count,
			ai_response,
			ai_answer,
			request_id,
		} = data || {};

		switch (messageType) {
			case 'notification':
				createNotification(
					text,
					null,
					false,
					7000,
					false,
					image_url,
					link,
					type === 'achievement'
						? () =>
								toggleAchievementsModal({
									open: true,
									data: { id: achievement_id, username },
								})
						: undefined,
				);
				break;

			case 'notification_count':
				setNotificationCount(new_notifications_count);
				break;

			case 'ai_explanation':
				if (currentRequestId === request_id) {
					getAiExplanationSuccess(request_id, ai_response);
				}
				break;

			case 'ai_check_answer':
				if (currentRequestId === request_id) {
					sendAnswerSuccess({
						is_correct: ai_answer,
						exercise_answer: { is_ai_open_answer: true },
					});
				}
				break;

			default:
				break;
		}
	}, [messages]);

	const connectWebSocket = () => {
		const ws = new WebSocket(WSS_URL);

		ws.onopen = () => {
			wsSubscribe(ws);
		};

		ws.onmessage = (message) => {
			try {
				const { message: newMessage, type } = JSON.parse(message.data);
				if (type && type === 'ping') return;
				if (newMessage) setMessages(newMessage);
			} catch (error) {
				console.error('Error parsing JSON:', error);
			}
		};

		ws.onclose = (e) => {
			if (!e.wasClean) {
				setTimeout(() => {
					connectWebSocket();
				}, 5000);
			}
		};

		ws.onerror = (error) => {
			console.error('WebSocket error:', error);
		};

		setSocket(ws);
	};

	const wsSubscribe = (ws) => {
		const identifier = {
			channel: 'UserChannel',
			x_auth_token: getAccessToken(),
		};

		const m = JSON.stringify({
			command: 'subscribe',
			identifier: JSON.stringify(identifier),
		});

		ws.send(m);
	};

	// for now empty but maybe in the future will be added some components as modal or so
	return <></>;
};

const mapStateToProps = ({ sidebarReducer, liveBattleReducer, exerciseNextReducer }) => ({
	userData: sidebarReducer.userData,
	battleRoomData: liveBattleReducer.battleRoomData,
	currentRequestId: exerciseNextReducer.currentRequestId,
});

const mapDispatchToProps = {
	createNotification: notificationActions.createNotification,
	toggleAchievementsModal: achievementsModalActions.toggleAchievementsModal,
	setNotificationCount: sidebarActions.setNotificationCount,
	getAiExplanationSuccess: nextExerciseActions.getAiExplanationSuccess,
	sendAnswerSuccess: nextExerciseActions.sendAnswerSuccess,
};

export default compose(connect(mapStateToProps, mapDispatchToProps), memo)(WebSocketComponent);
